import { colors } from '@frontend/constants';
import { Icon, Text, XStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';

export type CalendarEventDetailRowProps = {
  iconName: IconName;
  text: string;
};

export const CalendarEventDetailRow = ({ iconName, text }: CalendarEventDetailRowProps) => (
  <XStack alignItems="center" gap="sm">
    <Icon colorOverride={colors.neutral[700]} name={iconName} size={12} />
    {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
    <Text className="text-[11px] text-neutral-700" type="p-sm">
      {text}
    </Text>
  </XStack>
);
